import { ProjectConfig } from "../models/ProjectConfig";
export const updateConfigFromPage = (config: ProjectConfig) => {
  // try to fill crsf token from page
  if (window?.GLOBALS?.VARIABLES?.csrf) {
    config.network.crsfToken = window.GLOBALS.VARIABLES.csrf;
  } else if (
    window.GLOBALS.csrf_token &&
    typeof window.GLOBALS.csrf_token === "string"
  ) {
    config.network.crsfToken = window.GLOBALS.csrf_token
      .split(" ")[3]
      .replace("value=", "")
      .replace("'", "")
      .slice(0, -1);
  }

  // try to determine initial page url
  config.network.pathname = new URL(window.location.href).pathname;

  return config;
};
